import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../../stylesheets';

const setHover = ({ hoverColor }) => {
  if (hoverColor) {
    return css`
      &:hover {
        color: ${colors[hoverColor]};
      }
    `;
  } else {
    return '';
  }
};

const StyledIcon = styled.i`
  color: ${(props) => colors[props.color]};
  font-size: ${(props) => props.size}px;
  font-family: UneedMerchant;
  margin: 0 4px;
  font-style: normal;
  ${setHover}
`;

type Props = {
  color?: string,
  name: string,
  className?: string,
};

// @TODO add font size
Icon.defaultProps = {
  color: 'white',
  size: 16,
};
export default function Icon({ name, className, ...restProps }: Props) {
  return (
    <StyledIcon className={`icon icon-${name} ${className}`} {...restProps} />
  );
}
